export const RESOURCES = {
    Door_sensor: { label: "Door Sensor", value: "DoorSensor" },
    Exit_button: { label: "Exit Button", value: "ExitButton" },
    Fire_Alarm_in: { label: "Fire Alarm in", value: "FireAlarmIn" },
    Entry_button: { label: "Entry Button", value: "EntryButton" },
    Entry_relay: { label: "Entry Relay", value: "EntryRelay" },
    Exit_relay: { label: "Exit Relay", value: "ExitRelay" },
    Pass_control: { label: "Pass Control", value: "PassControl" },
    Open_button: { label: "Open Button", value: "OpenButton" },
    Open_relay: { label: "Open Relay", value: "OpenRelay" },
    Lock: { label: "Lock", value: "Lock" },
    Alarm_out: { label: "Alarm Out", value: "AlarmOut" },
    Block: { label: "Block", value: "Block" },
    Block_Turnstile: { label: "Block Turnstile", value: "BlockTurnstile" },
    Emergency_open: { label: "Emergency Open", value: "EmergencyOpen" },
    Loop_sensor: { label: "Loop Sensor", value: "LoopSensor" },
    "0": { label: "RFID", value: "RFID" },
    "1": { label: "KEYPAD", value: "KEYPAD" },
    "2": { label: "FINGER", value: "FINGER" },
    "3": { label: "FACE", value: "FACE" },
}

export const TEMPLATE_INFO = {
    reader: {
        "1": { id: 1, label: "Wiegant port 1" },
        "2": { id: 2, label: "Wiegant port 2" },
        direction: {
            '0': "ENTRY",
            '1': "EXIT",
        }
    },
    input: {
        "0": {
            "1": { id: 1, label: "REX 1" },
            "2": { id: 2, label: "DOOR 1" },
            "3": { id: 3, label: "IN 1" },
            "4": { id: 4, label: "IN 2" },
        }
    },
    output: {
        "0": {
            "1": { id: "1", label: "RELAY 1" },
            "2": { id: "2", label: "AUX GND" }
        },

        relay_mode: {
            "0": { id: "1", label: "Trigger" },
            "1": { id: "2", label: "Impulse" }
        }

    }

}